import { render, staticRenderFns } from "./ReadyToBeDelivered.vue?vue&type=template&id=47e94be0&scoped=true&"
import script from "./ReadyToBeDelivered.vue?vue&type=script&lang=js&"
export * from "./ReadyToBeDelivered.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToBeDelivered.vue?vue&type=style&index=0&id=47e94be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e94be0",
  null
  
)

export default component.exports